import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'

export type PublishCampaignSuccessModalProps = Readonly<{
  isOpen: boolean
  handleClose: () => void
}>

export function PublishCampaignSuccessModal({ isOpen, handleClose }: PublishCampaignSuccessModalProps) {
  const { t } = useTranslation()

  return (
    <Modal open={isOpen} onClose={handleClose} aria-labelledby="publish-campaign-success">
      <AcknowledgeModal
        result="positive"
        title={t('typography.givingCampaigns.publishCampaign.success.title')}
        buttonText={t('button.close')}
        handleClose={handleClose}
        buttonTestId="success-modal-btn"
      >
        {t('typography.givingCampaigns.publishCampaign.success.description')}
      </AcknowledgeModal>
    </Modal>
  )
}
